module.exports = __webpack_public_path__ + "static/media/restyling.ca08e3a0.png";